import { render, staticRenderFns } from "./DescriptionAddress.vue?vue&type=template&id=f03d67bc&scoped=true"
import script from "./DescriptionAddress.vue?vue&type=script&lang=js"
export * from "./DescriptionAddress.vue?vue&type=script&lang=js"
import style0 from "./DescriptionAddress.vue?vue&type=style&index=0&id=f03d67bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f03d67bc",
  null
  
)

export default component.exports